import { styled } from '@mui/material/styles';
import dynamic from 'next/dynamic';
import CasinoAndSportBox from '@/components/pages/main/CasinoAndSportBox';
import { Stack } from '@mui/system';
import HomepageBannerBox from '@/components/features/common/WelcomeCarousel';
import { Box } from '@mui/material';

//
// const HomepageBannerBox = dynamic(
//   () => import('@/components/pages/common/WelcomeCarousel'),
//   {
//     ssr: true,
//   },
// );
//
// const CasinoAndSportBox = dynamic(
//   () => import('@/components/pages/main/CasinoAndSportBox'),
//   {
//     ssr: true,
//   },
// );
const PaymentBox = dynamic(() => import('@/components/pages/main/Payment'), {
  ssr: false,
});

const Bets = dynamic(() => import('@/components/features/common/Bets'), {
  ssr: false,
  loading: () => (
    <Box
      sx={{
        minHeight: 600,
      }}
    ></Box>
  ),
});

/* eslint-disable-next-line */

const StyledMainPage = styled(Stack)(({ theme }) => ({
  maxHeight: '100%',
  [theme.breakpoints.up('md')]: {
    marginTop: theme.spacing(8),
  },
  [theme.breakpoints.down('md')]: {
    marginTop: 0,
  },
}));

export function MainPage() {
  return (
    <StyledMainPage direction={'column'} gap={4}>
      <HomepageBannerBox />
      <CasinoAndSportBox />
      {/*<GameSearch />*/}
      {/*There is currently no payment and no need to show*/}
      {/*<PaymentBox />*/}
    </StyledMainPage>
  );
}

export default MainPage;
